import axios from "axios";
import {API} from "../config";

const path = "/servico-acolhimento";
const subPath = "/gestao"

class GestaoSAService {
  novaGestaoSA(id, gestaoSA){
    let formData = new FormData();

    for ( let key in gestaoSA ) {
      if(!(key==="anexoEstatuto" && gestaoSA[key]===null)){
        formData.append(key, gestaoSA[key]);
      }
    }

    return axios.post(API + path + `/${id}` + subPath, formData);
  }

  getGestaoSA(id){
    return axios.get(API + path + `/${id}` + subPath)
  }

  atualizarGestaoSA(id, gestaoSA){
    let formData = new FormData();

    for ( let key in gestaoSA ) {
      if(!(key==="anexoEstatuto" && gestaoSA[key]===null)){
        formData.append(key, gestaoSA[key]);
      }
    }

    return axios.put(API + path + `/${id}` + subPath, formData);
  }
}
const instanceGestao = new GestaoSAService();
export default instanceGestao;